/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function navbar(theme, ownerState) {
  const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
  const { transparentNavbar, absolute, light, darkMode, miniSidenav } = ownerState;

  const { dark, white, text, transparent, background } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;

  // 2026-05-25 sidebar 寬度（要跟 SidenavRoot.sidebarWidth + DashboardLayout 同步）
  const SIDEBAR_WIDTH_FULL = 250;
  const SIDEBAR_WIDTH_MINI = 96;

  return {
    // 2026-05-25 改成永遠純白 + 無圓角 + 真的固定在頂端（position: fixed）
    // 2026-05-25 Sean 不要陰影漸層，clean 平接
    boxShadow: "none",
    backdropFilter: "none",
    backgroundColor: darkMode ? `${background.default} !important` : `${white.main} !important`,
    borderBottom: "none",

    color: () => {
      let color;

      if (light) {
        color = white.main;
      } else if (transparentNavbar) {
        color = text.main;
      } else {
        color = dark.main;
      }

      return color;
    },
    // 2026-05-25 fixed 定位，sidebar 跟 navbar 無縫接 + 滑動時永遠在頂
    position: "fixed !important",
    top: "0 !important",
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 1100,
    minHeight: pxToRem(75),
    display: "grid",
    alignItems: "center",
    borderRadius: 0,
    margin: 0,
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(8),
    paddingRight: 0,
    paddingLeft: 0,

    // 在 xl 以上（sidebar 顯示時）navbar 從 sidebar 右側開始
    [breakpoints.up("xl")]: {
      left: miniSidenav ? `${SIDEBAR_WIDTH_MINI}px` : `${SIDEBAR_WIDTH_FULL}px`,
      width: miniSidenav
        ? `calc(100% - ${SIDEBAR_WIDTH_MINI}px)`
        : `calc(100% - ${SIDEBAR_WIDTH_FULL}px)`,
      transition: transitions.create(["left", "width"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      [breakpoints.up("sm")]: {
        minHeight: "auto",
        padding: `${pxToRem(4)} ${pxToRem(16)}`,
      },
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  flexDirection: "initial",
  alignItems: "flex-start",
  justifyContent: "space-between",
  pt: 0.5,
  pb: 0.5,

  [breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0",
    paddingBottom: "0",
  },
});

const navbarRow = ({ breakpoints }, { isMini }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "29%",

  [breakpoints.up("md")]: {
    justifyContent: isMini ? "space-between" : "stretch",
    width: isMini ? "100%" : "max-content",
  },

  [breakpoints.up("xl")]: {
    justifyContent: "stretch !important",
    width: "max-content !important",
  },
});

const navbarIconButton = ({ typography: { size }, breakpoints }) => ({
  px: 1,

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.xl} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

const navbarMobileMenu = () => ({
  display: "inline-block",
  lineHeight: 0,
});

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu };
